<div class="google-image-dialog">
    <div class="google-image-header">
      <button type="button" class="close-btn" (click)="close()" aria-label="Close GOOGLE-IMAGE Info">
        &times;
      </button>
  
      <img src="assets/logos/google.svg" alt="GOOGLE-IMAGE Logo" class="google-image-logo" />
      <h2>GOOGLE-IMAGE</h2>
      <span class="badge-optimal">Image Search • Fast Visual Discovery • Web-Scale Results</span>
    </div>
  
    <div class="google-image-body">
  
      <p class="intro">
        <strong>GOOGLE-IMAGE</strong> is a powerful
        <span class="highlight">image search and discovery tool</span>
        that helps users find visually similar images, source pages, and related content across the web.
        It supports fast exploration of visuals by keyword, reverse image lookup, and contextual matching,
        making it ideal for research, inspiration, verification, and content sourcing.
      </p>
  
      <ul class="qualities">
        <li>
          <span class="icon">🔎</span>
          <span>
            <strong>Web-Scale Image Discovery:</strong>
            Search across massive amounts of indexed images to quickly find relevant visuals and related sources.
          </span>
        </li>
  
        <li>
          <span class="icon">🖼️</span>
          <span>
            <strong>Reverse Image Search:</strong>
            Upload an image or paste a URL to find matching images, similar visuals, and likely origin pages.
          </span>
        </li>
  
        <li>
          <span class="icon">⚡</span>
          <span>
            <strong>Fast Filtering & Refinement:</strong>
            Narrow results by size, color, type, time, and usage rights to get the most usable images quickly.
          </span>
        </li>
  
        <li>
          <span class="icon">🧭</span>
          <span>
            <strong>Visual Exploration:</strong>
            Discover related images and categories through similarity clustering and “related searches.”
          </span>
        </li>
  
        <li>
          <span class="icon">🧾</span>
          <span>
            <strong>Context from Source Pages:</strong>
            Each image can be traced back to the page it came from, helping with credibility checks and citations.
          </span>
        </li>
  
        <li>
          <span class="icon">✅</span>
          <span>
            <strong>Useful for Research & Verification:</strong>
            Great for identifying duplicates, checking where an image appears online, and confirming authenticity.
          </span>
        </li>
      </ul>
  
      <div class="when-use">
        <h3>Why Users Choose GOOGLE-IMAGE</h3>
        <ul>
          <li><strong>Rapid discovery</strong> of images for inspiration, design, and brainstorming</li>
          <li><strong>Reverse lookups</strong> to find origins, duplicates, or higher-resolution versions</li>
          <li><strong>Filtering tools</strong> for size, type, date, and usage rights</li>
          <li><strong>Source tracing</strong> for credibility and research workflows</li>
          <li><strong>Visual similarity search</strong> to explore related concepts and styles</li>
        </ul>
  
        <div class="tip">
          <span>💡</span>
          <span>
            <strong>Pro Tip:</strong> Use reverse image search when you need to verify a picture,
            find the original source, or locate higher-quality versions.
          </span>
        </div>
  
        <div class="comparison">
          <h3>What Makes GOOGLE-IMAGE Feel “Powerful” in Real Use</h3>
          <p>
            GOOGLE-IMAGE feels powerful because it combines massive coverage with fast refinement tools,
            helping users move from “I need an image” to “this is the right one” quickly. Users typically notice:
          </p>
          <ul>
            <li>Better speed finding relevant visuals compared to browsing manually</li>
            <li>More accurate matches when using reverse image lookup</li>
            <li>Quick narrowing using filters like size/type/rights</li>
            <li>Stronger confidence when verifying sources and duplicates</li>
          </ul>
        </div>
      </div>
  
    </div>
  </div>
  